import { createContext, useContext, useState } from "react";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [msg, setMsg] = useState(null);

  const notify = (text) => {
    setMsg(text);
    setTimeout(() => setMsg(null), 3000);
  };

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}

      {msg && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            background: "#ff4d4f",
            color: "white",
            padding: "12px 18px",
            borderRadius: 8,
            boxShadow: "0 4px 10px rgba(0,0,0,.15)",
            zIndex: 9999
          }}
        >
          {msg}
        </div>
      )}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
